import { Button, Heading, Markdown, Typography } from '@altify/components';
import { View } from 'react-native';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import RebalanceImage from '../assets/RebalanceIcon.svg';
import { useGetFeatureFlagsQuery } from 'store/slices/feature-flags-api';
import { exploreProductsContent } from '../explore.content';
import { useContent } from '@altify/utils';

const RebalanceInProgressModal = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) => {
  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const featureFlag = featureFlags?.find(flag => flag.code === 'REBALANCE');
  const displayMessage =
    featureFlag?.displayMessage?.replace(/\\n/g, '\n') || '';
  
  const localizedContent = useContent(exploreProductsContent);

  return (
    <DialogOrBottomSheet
      blurEnabled={true}
      isOpen={isOpen}
      onClose={handleClose}
      backgroundColor="#0C1C2C"
      footerContent={
        <View className="flex flex-col gap-4 px-4 my-4">
          <Button
            onPress={() => {
              handleClose();
            }}
            text={localizedContent.gotIt}
            className="w-full"
          />
        </View>
      }>
      <View className="w-full flex flex-col items-center gap-4 py-4 px-8 gap-6">
        <img src={RebalanceImage} />
        <Heading level={4} className="text-center">
          {featureFlag?.name}
        </Heading>
        <Markdown
          textColor="white"
          styles={{
            text: {
              textAlign: 'center',
              color: '#ffffff',
              display: 'flex',
              fontFamily: 'Bozon',
              justifyContent: 'center',
              lineHeight: 25,
              fontWeight: 300,
            },
            paragraph: {
              color: '#ffffff',
              justifyContent: 'center',
              fontFamily: 'Bozon',
              lineHeight: 25,
              fontWeight: 300
            }
          }}>
          {displayMessage}
        </Markdown>
      </View>
    </DialogOrBottomSheet>
  );
};

export default RebalanceInProgressModal;
